import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { A11YLiveMessage as UI, A11YLiveMessageProps as UIProps } from '@lumapps/lumx/react/utils';

export interface A11YLiveMessageProps extends UIProps {
    scope?: string;
}

const NAMESPACE = 'a11y-live-message';

/**
 * Live region to read a message to screen readers.
 * Messages can be "polite" and be read when possible or
 * "assertive" and interrupt any message currently be read. (To be used sparingly)
 *
 * More information here: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Live_Regions
 *
 * @family A11Y
 * @param A11YLiveMessageProps
 * @returns A11YLiveMessage
 */
export const A11YLiveMessage: React.FC<A11YLiveMessageProps> = ({ scope = NAMESPACE, children, ...forwardedProps }) => {
    const { get } = useDataAttributes(scope);

    return (
        <UI {...get({ element: 'wrapper' })} {...forwardedProps}>
            {children}
        </UI>
    );
};
